import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import logo from '../Images/SmartLifeChoice-Logo.png';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-about">
                        <div className="footer-logo">
                            <img src={logo} alt="SmartLifeChoice" className="footer-logo-image" />
                            <span className="footer-logo-text">SmartLifeChoice</span>
                        </div>
                        <p>
                            Your trusted source for evidence-based health and fitness information.
                            We believe in a balanced approach to wellness that nurtures both body and mind.
                        </p>
                        <div className="social-links">
                            <a href="#" className="social-link">
                                <Facebook size={18} />
                            </a>
                            <a href="#" className="social-link">
                                <Twitter     size={18} />
                            </a>
                            <a href="#" className="social-link">
                                <Instagram size={18} />
                            </a>
                            <a href="#" className="social-link">
                                <Youtube size={18} />
                            </a>
                        </div>
                    </div>

                    <div className="footer-links">
                        <h3>Quick Links</h3>
                        <ul className="footer-link-list">
                            <li><Link to="/" className="footer-link">Home</Link></li>
                            <li><Link to="/about" className="footer-link">About Us</Link></li>
                            <li><Link to="/contact" className="footer-link">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="footer-links">
                        <h3>Policy</h3>
                        <ul className="footer-link-list">
                            <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
                            <li><Link to="/terms-conditions" className="footer-link">Terms & Conditions</Link></li>
                            <li><Link to="/cookie-policy" className="footer-link">Cookie Policy</Link></li>
                            <li><Link to="/health-disclaimer" className="footer-link">Health Disclaimer</Link></li>
                        </ul>
                    </div>

                    <div className="footer-links">
                        <h3>Newsletter</h3>
                        <p>Subscribe to our newsletter for the latest updates on health and fitness.</p>
                        <form className="newsletter-form mt-2">
                            <input type="email" placeholder="Your email address" className="form-input" />
                            <button type="submit" className="btn btn-primary mt-1">Subscribe</button>
                        </form>
                    </div>
                </div>

                <div className="copyright">
                    <p>&copy; {new Date().getFullYear()} SmartLifeChoice. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
